import { FormEditor } from './../../models/editors/form-editor.base.model';

import * as appConfig from '../../app.config';

export class Textarea extends FormEditor<string> {
    controlType = 'textarea';
    height: number;
    hasWysiwyg: string;

    constructor(options: {} = {}) {
        super(options);
        this.height = options['height'] || appConfig.textareaDefaultHeight;
        this.hasWysiwyg = options['hasWysiwyg'] || false;
    }
}
